import React from 'react';
import { Box, Container, Typography, Grid, TextField, Button, Card, CardContent, Avatar, useTheme, Link } from '@mui/material';
import { Email, Phone, SupportAgent, HelpOutline } from '@mui/icons-material';
import { Scrollbars } from 'react-custom-scrollbars-2';

import config from '../config/config';
import ContactUsForm from '../components/forms/ContactUsForm';

const Contact = () => {
    const theme = useTheme();

    return (
        <Box sx={{ width: '100%', paddingY: 2 }}>
            <Scrollbars>

                <Container maxWidth="lg">
                    <Typography variant="h3" align="center" sx={{ fontWeight: 'bold', mb: 6 }}>
                        Contact Us
                    </Typography>
                    <Grid container spacing={6}>
                        {/* Contact Information Section */}
                        <Grid item xs={12} md={6}>
                            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <CardContent>
                                    <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
                                        How We Can Help
                                    </Typography>
                                    <Typography variant="body1" sx={{ mb: 3 }}>
                                        We’re here to support you with:
                                    </Typography>
                                    <ul>
                                        <li><Typography variant="body1">Technical issues or troubleshooting</Typography></li>
                                        <li><Typography variant="body1">Guidance on using our AI-powered tools</Typography></li>
                                        <li><Typography variant="body1">Academic and study-related assistance</Typography></li>
                                        <li><Typography variant="body1">Suggestions and feedback on how we can improve</Typography></li>
                                    </ul>
                                    <Typography variant="body1" sx={{ mt: 3, mb: 2 }}>
                                        Feel free to reach out to us directly via email or phone.
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item>
                                            <Avatar sx={{ bgcolor: 'primary.dark' }}>
                                                <Email
                                                    sx={{
                                                        color: 'primary.light',
                                                    }}
                                                />
                                            </Avatar>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="body1" sx={{ marginBottom: 2 }}>
                                                Email: <Link href={`mailto:${config.supportMail}`} color="primary.dark">{config.supportMail}</Link>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2} sx={{ mt: 1 }}>
                                        <Grid item>
                                            <Avatar sx={{ bgcolor: 'primary.dark' }}>
                                                <Phone
                                                    sx={{
                                                        color: 'primary.light',
                                                    }}
                                                />
                                            </Avatar>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="body1">
                                                Phone:{" "}
                                                <span
                                                    style={{
                                                        color: theme.palette.primary.dark,
                                                    }}
                                                >
                                                    {config.phoneNumber}
                                                </span>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Contact Form Section */}
                        <ContactUsForm />
                    </Grid>
                </Container>
            </Scrollbars>
        </Box>
    );
};

export default Contact;
